<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo" [routerLink]="['/dashboard/default']">
              <img
                class="img-fluid for-light"
                src="assets/images/logo/logo_dark.png"
                alt="looginpage" />
              <img
                class="img-fluid for-dark"
                src="../../../assets/images/logo/logo_light.png"
                alt="looginpage"
            /></a>
          </div>
          <div data-test="login-form" class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>{{'login.title' | translate}}</h4>
              <p>{{'login.subtitle' | translate}}</p>
              <div class="form-group">
                <label class="col-form-label">{{'forms.email' | translate}}</label>
                <input
                  data-test="email"
                  class="form-control"
                  type="email"
                  placeholder="super@admin.com"
                  formControlName="email"
                />
                @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['required']) {
                <div class="text text-danger mt-1">{{'forms.error_email_required' | translate }}</div>
                } @if (loginForm.controls['email'].touched &&
                loginForm.controls['email'].errors?.['email']) {
                <div class="text text-danger mt-1">{{'forms.error_email_invalid' | translate }}</div>
                }
              </div>
              <div class="form-group">
                <label class="col-form-label">{{'forms.password' | translate}}</label>
                <div class="form-input position-relative">
                  <input
                    data-test="password"
                    class="form-control"
                    type="password"
                    name="login[password]"
                    [type]="show ? 'text' : 'password'"
                    placeholder="*********"
                    formControlName="password"
                  />
                  <div class="show-hide">
                    <span (click)="show = !show" [class.show]="show"></span>
                  </div>
                  @if (loginForm.controls['password'].touched &&
                  loginForm.controls['password'].errors?.['required']) {
                  <div class="text text-danger mt-1">{{'forms.error_password_required' | translate}}</div>
                  }
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input
                    data-test="remember-me"
                    id="rememberMe"
                    type="checkbox"
                    formControlName="rememberMe"
                  />
                  <label class="text-muted" for="rememberMe"
                    >{{ 'login.remember_password' | translate }}</label
                  >
                </div>
                <a
                  data-test="forgot-password"
                  class="link"
                  [routerLink]="['/auth/reset-password']"
                  >{{ 'login.have_you_forgot_password' | translate }}</a
                >
                <div class="text-end mt-3">
                  <button
                    data-test="login-button"
                    class="btn btn-primary btn-block w-100"
                    type="submit"
                    [disabled]="!loginForm.valid"
                    (click)="login()"
                  >
                    {{ 'button_labels.login' | translate }}
                  </button>
                </div>
              </div>
              <!--<p class="mt-4 mb-0 text-center">Don't have account?
                                <a class="ms-2" [routerLink]="['/authentication/register-simple']">Create Account</a>
                            </p>-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
